import React, { useState, useEffect } from "react";
import TambahTerimaNotis from "components/STPopup/TambahTerimaNotis";
import PropTypes from "prop-types";
import { Grid, MenuItem, Button, TextField, FormControl, InputLabel, Select } from "@mui/material";
import MDBox from "components/MDBox";
import RefreshIcon from "@mui/icons-material/Refresh";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import PrintIcon from "@mui/icons-material/Print";
import MDButton from "components/MDButton";
import { getCurrentUserDepartment } from "utils/userUtils";
import { buttonStyles } from "utils/buttonStyles";
import { searchBoxStyles } from "utils/pageHeaderStyles";

function NotisSearch({ search, onChange, onRebuild, onPreview, onPrintBorang, loading, selectedCount = 0, onTerimaNotis, tabIndex = 0, onLihat, onPost, onHapus, hapusDisabled, lihatDisabled, forceUUU = false }) {
  const [zones, setZones] = useState([]);

  useEffect(() => {
    // Fetch zones for dropdown; for UUU use /api/zones/distinct for accuracy
    const loadZones = async () => {
      try {
        const dept = getCurrentUserDepartment();
        const url = (dept.toLowerCase() === 'uuu' || forceUUU)
          ? `/api/zones/distinct`
          : `/api/zones?limit=500&page=1`;
        const res = await fetch(url, {
          headers: { "X-User-Department": dept },
        });
        const json = await res.json();
        const list = Array.isArray(json?.data)
          ? json.data
          : [];
        // distinct endpoint already returns strings; list endpoint returns objects
        const normalized = typeof list[0] === 'string' ? list : list.map((z) => z.zon).filter(Boolean);
        setZones(normalized);
      } catch (e) {
        // non-blocking
      }
    };
    loadZones();
    // only on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dept = (getCurrentUserDepartment() || '').toLowerCase();
  const isUUU = forceUUU || dept === 'uuu';

  return (
    <MDBox sx={searchBoxStyles.container}>
      <MDTypography variant="h6" fontWeight="bold" mb={1.5}>
        Carian
      </MDTypography>
      <Grid container spacing={1.5} alignItems="center">
        {/* No Akaun */}
        <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 2 }}>
          <TextField
            label="No Akaun"
            name="no_akaun"
            size="small"
            value={search.no_akaun || ""}
            onChange={onChange}
            fullWidth
          />
        </Grid>
        {/* Zon */}
        <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 2 }}>
          <FormControl
            fullWidth
            size="small"
            sx={searchBoxStyles.dropdownField}
          >
            <InputLabel>Zon</InputLabel>
            <Select
              label="Zon"
              name="zon"
              value={search.zon}
              onChange={onChange}
              fullWidth
              IconComponent={() => null}
            >
              <MenuItem value="">SEMUA</MenuItem>
              {zones.map((z) => (
                <MenuItem key={z} value={z}>{z}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {/* Jenis Notis removed: single-stage model (only Notis Pertama exists) */}
      </Grid>
      <Grid container spacing={1.5} alignItems="center">
        {isUUU ? (
          // UUU users: only LIHAT button
          <>
            <Grid item xs={12} md={12} sx={{ mb: 2, display: "flex", justifyContent: "flex-start", gap: 1 }}>
              <Button
                size="small"
                variant="contained"
                sx={{ ...buttonStyles.primary, m: 0, px: 2, minWidth: 0 }}
                onClick={onLihat}
                disabled={Boolean(lihatDisabled)}
              >
                LIHAT
              </Button>
            </Grid>
          </>
        ) : tabIndex === 0 ? (
          <>
            <Grid item xs={6} md={6} sx={{ mb: 2, display: "flex", justifyContent: "flex-start", gap: 1 }}>
              <Button
                startIcon={<PrintIcon />}
                size="small"
                variant="contained"
                sx={{ ...buttonStyles.preview, m: 0, px: 2, minWidth: 0 }}
                onClick={onPreview}
              >
                PREVIEW
              </Button>
              <Button
                size="small"
                variant="contained"
                sx={{ ...buttonStyles.print, m: 0, px: 2, minWidth: 0 }}
                onClick={onPrintBorang}
                disabled={selectedCount === 0 || !search.zon}
              >
                PRINT BORANG
              </Button>
            </Grid>
            <Grid item xs={9} md={6} sx={{ mb: 2, display: "flex", justifyContent: "flex-end", gap: 1 }}>
              <Button
                size="small"
                variant="contained"
                sx={{ ...buttonStyles.save, m: 0, px: 2, minWidth: 0 }}
                disabled={selectedCount === 0}
                onClick={onTerimaNotis}
              >
                TERIMA NOTIS
              </Button>
              <Button
                size="small"
                variant="contained"
                sx={{ ...buttonStyles.primary, m: 0, px: 2, minWidth: 0 }}
                startIcon={<RefreshIcon />}
                onClick={onRebuild}
                disabled={loading}
              >
                {loading ? "Rebuilding..." : "Rebuild Notis"}
              </Button>
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={6} md={6} sx={{ mb: 2, display: "flex", justifyContent: "flex-start", gap: 1 }}>
              <Button
                size="small"
                variant="contained"
                sx={{ ...buttonStyles.primary, m: 0, px: 2, minWidth: 0 }}
                onClick={onLihat}
                disabled={Boolean(lihatDisabled)}
              >
                LIHAT
              </Button>
            </Grid>
            <Grid item xs={6} md={6} sx={{ mb: 2, display: "flex", justifyContent: "flex-end", gap: 1 }}>
              <Button
                size="small"
                variant="contained"
                sx={{ ...buttonStyles.save, m: 0, px: 2, minWidth: 0 }}
                onClick={onPost}
              >
                POST
              </Button>
              <Button
                size="small"
                variant="contained"
                sx={{ ...buttonStyles.delete, m: 0, px: 2, minWidth: 0 }}
                onClick={onHapus}
                disabled={Boolean(hapusDisabled)}
              >
                HAPUS
              </Button>
            </Grid>
          </>
  )}
      </Grid>
    </MDBox>
  );
}


NotisSearch.propTypes = {
  search: PropTypes.shape({
    stage: PropTypes.string,
    zon: PropTypes.string,
    no_akaun: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onRebuild: PropTypes.func,
  onPreview: PropTypes.func,
  onPrintBorang: PropTypes.func,
  loading: PropTypes.bool,
  zones: PropTypes.array,
  selectedCount: PropTypes.number,
  onTerimaNotis: PropTypes.func,
  tabIndex: PropTypes.number,
  onLihat: PropTypes.func,
  onPost: PropTypes.func,
  onHapus: PropTypes.func,
  hapusDisabled: PropTypes.bool,
  lihatDisabled: PropTypes.bool,
  forceUUU: PropTypes.bool,
};

NotisSearch.defaultProps = {
  onRebuild: () => {},
  onPreview: () => {},
  onPrintBorang: () => {},
  loading: false,
  zones: [],
  forceUUU: false,
};

export default NotisSearch;
